import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Inline } from '@atlaskit/primitives/compiled';
import { CellWrapper } from '@atlassian/jira-directory-base-v3/src/ui/table-cells/styled.tsx';
import type { ProjectCategoryCell$key } from '@atlassian/jira-relay/src/__generated__/ProjectCategoryCell.graphql';

type Props = {
	project: ProjectCategoryCell$key;
};

export const ProjectCategoryCell = ({ project }: Props): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment ProjectCategoryCell on JiraProject {
				category {
					name
				}
			}
		`,
		project,
	);

	return data?.category?.name ? (
		<Inline>{data.category.name}</Inline>
	) : (
		<CellWrapper>{data?.category?.name}</CellWrapper>
	);
};
